import { faArrowUpRightFromSquare, faCircleMinus, faCirclePlus, faEye, faGripLines, faHeartCircleMinus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef, useState } from 'react';
import { DragDropContext, Draggable, Droppable, DropResult } from 'react-beautiful-dnd';
import { useLocation, useNavigate } from 'react-router-dom';
import { BannerPreview } from '../../components/bannerPreview/BannerPreview';
import GenricMultiSelect from '../../components/Input/GenericMultiSelect';
import { Loader } from '../../components/loader/Loader';
import { ConfirmationPopUp } from '../../components/popup/confirmationPopUp';
import { getAllBanners } from '../../services/bannerServices';
import { setCurrentBanner } from '../../stateManagement/actions/bannerActions';
import { Banner, BannerElement } from '../../types';
import { bannerTemplates } from '../createBanner/bannerTemplates';
import { bannerData } from '../createBanner/bannerTypes';
import { blockBannerSelectionProps } from './CreateBlockTypes';
// import { createBucketNavigate, BannerSelectionProps } from './CreateBucketTypes';

function BlockBannerSelectionOld(props:blockBannerSelectionProps) {
    const currentRoute = (useLocation().pathname);
    const navigate = useNavigate();
    // const locationState: createBucketNavigate = location.state as createBucketNavigate;
    const [bannerOptions,setBannerOptions] = useState<string[]>([]);
    const [selectedBanners,setSelectedBanners] = useState<string[]>([]);
    const needBasedBannersData = useRef<Banner[]>([]);
    const [currentBannerElements,setCurrentBannerElements] = useState<BannerElement[]>([]);
    const [openBannerPreview,setOpenBannerPreview] = useState<boolean>(false);
    const [openConfirmModal,setOpenConfirmModal] = useState<boolean>(false);
    const targetBanner = useRef<Banner>();
    const [showLoader,setShowLoader] = useState<boolean>(false);
    const allBannersRef = useRef<Banner[] | null>(null);
    useEffect(() => {
        async function getAndSetNeedBasedBanners(){
            setShowLoader(true);
            let allBanners: Banner[] | null = allBannersRef.current;
            if(!allBanners){
                allBanners = await getAllBanners() as Banner[];
                allBannersRef.current = allBanners;
            }
            
            const templateFilteredBanners = allBanners.filter((banner: Banner) => {
                return props.bannerTemplates.includes(banner.bannerType);
            })
            let prevMappedBanner: string[] = [];
            const blockBannerIds = props.bannerIds
            const allBlocks = props.allBlocks;
            const bannerIdSet = new Set();
            allBlocks.forEach((blockObj: any) => {
                blockObj?.bannerIds?.forEach((id: string) => {
                    bannerIdSet.add(id);
                })
            })
            const bannersNotLinkedToBlocks = templateFilteredBanners.filter(bannerObj => {
                return !bannerIdSet.has(bannerObj.id);
            })
            let finalBannerState: Banner[] = [];
            if(props.showAllSelected){
                finalBannerState = bannersNotLinkedToBlocks
            }else{
                prevMappedBanner = bannersNotLinkedToBlocks.map((bannerObj) => bannerObj.bannerName);
            }

            if(props.view==="edit" && blockBannerIds){
                const prevSelectedBanners = blockBannerIds.map((bannerId: string) => {
                    return templateFilteredBanners.find((banner: Banner) => banner.id === bannerId);
                }).filter((banner: Banner | undefined) => banner!== undefined) as Banner[];

                finalBannerState = [...prevSelectedBanners,...finalBannerState,];
                // props.setBanners(bannerState as Banner[]);
            }
            props.setBanners(finalBannerState as Banner[]);
            setBannerOptions(prevMappedBanner);
            needBasedBannersData.current = templateFilteredBanners;
            setShowLoader(false);
        }
        getAndSetNeedBasedBanners();
    },[props.bannerTemplates]);
    function handleSelectBanners(selectedBannerOptions: string[]){
        setSelectedBanners(selectedBannerOptions);
    }
    function handleAddBanners(){
        const newNeedBasedBanners = selectedBanners.map((bannerName: string) => {
            return needBasedBannersData.current.find((bannerObj: any) => bannerObj.bannerName === bannerName);
        })
        const newBannerState = [...props.banners,...newNeedBasedBanners];
        props.setBanners(newBannerState as Banner[]);
        const newBannerOptions = bannerOptions.filter((bannerName: string) => {
            return !selectedBanners.find((selectedBannerName: string) => selectedBannerName === bannerName);
        })
        setSelectedBanners([]);
        setBannerOptions(newBannerOptions);
    }
    function handleDragOnEnd(result: DropResult) {
        if(result.destination!==null){
          const items = Array.from(props.banners);
          const [reorderedItem] = items.splice(result.source.index, 1);
          if (result.destination)
            items.splice(result.destination.index, 0, reorderedItem);
    
          props.setBanners(items);
        }
      }
    function handleBannerRemove(targetBanner: Banner){
        const newFilterdBanners = props.banners.filter((banner: Banner) => {
            return banner.bannerName !== targetBanner.bannerName;
        })
        props.setBanners(newFilterdBanners);
        setBannerOptions([targetBanner.bannerName,...bannerOptions]);
    }
    function handleEye(targetBanner: Banner){
        setCurrentBannerElements(targetBanner.bannerElements);
        setOpenBannerPreview(true);
    }
    function navigateToEditBanner(){
        if(targetBanner.current){
            const bannerData = {...targetBanner.current, bannerTemplateType: bannerTemplates.find((bannerTemplate) => targetBanner.current?.bannerType === bannerTemplate.id)?.label};
            // setCurrentBanner(bannerData as bannerData);
            if(currentRoute.includes("/dashboard/")){
                navigate("/dashboard/manageBannerStudio/banner",{
                    state: {
                        isBucketEdit: true,
                        currentBanner: bannerData
                    }
                });
            }else{
                navigate("/manageBanner/banner",{
                    state: {
                        isBucketEdit: true,
                        currentBanner: bannerData
                    }
                })
            }
            
        }
    }
    return (
        !showLoader?<>
            {bannerOptions.length>0 && <><label className="create-basket-input-labels">
                {props.label}
            </label>
            <div className="create-bucket-primary-types-row">
                <GenricMultiSelect
                    className="create-bucket-primary-type-multi-select"
                    options={bannerOptions}
                    label={""}
                    selectedOptions={selectedBanners}
                    handleMultiSelectState={handleSelectBanners}
                    isRequired={false}
                    params={{ size: "small" }}
                />
                <FontAwesomeIcon
                    onClick={handleAddBanners}
                    className="create-bucket-plus-icon"
                    icon={faCirclePlus}
                />
            </div></>}
            <BannerPreview openBannerPreview={openBannerPreview} setOpenBannerPreview={setOpenBannerPreview} bannerElements={currentBannerElements}/>
            {props.banners?.length>0 && <DragDropContext onDragEnd={handleDragOnEnd}>
            <Droppable droppableId="droppableNeedBasedBanners">
                {(provided) => (
                    <div className="create-bucket-need-based-banners-container" {...provided.droppableProps}
                    ref={provided.innerRef}>
                    {
                        props.banners.map((bannerObj: Banner,index: number) => {
                            return (
                                <Draggable 
                                    key={bannerObj.bannerName}
                                    draggableId={bannerObj.bannerName}
                                    index={index}
                                >
                                    {(provided) => (
                                        <div className='card' ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                            <div className="item_card" >
                                                <span>
                                                    <FontAwesomeIcon  className='transfer_list_grip_lines_icon' icon={faGripLines} />
                                                    {bannerObj.bannerName}
                                                </span>
                                                <span className='homepage_icon_container'>
                                                    <span onClick={() => handleEye(bannerObj)}>
                                                        <FontAwesomeIcon icon={faEye} />
                                                    </span>
                                                        {props.view!=="create" && <span><FontAwesomeIcon icon={faArrowUpRightFromSquare} onClick={()=>{
                                                            targetBanner.current = bannerObj as Banner;
                                                            setOpenConfirmModal(true)
                                                            }} /></span>}
                                                    <span onClick={() => handleBannerRemove(bannerObj)}>
                                                        <FontAwesomeIcon icon={faCircleMinus} />
                                                    </span>
                                                </span>
                                        </div>
                                        
                                    </div>
                                    )}
                                
                                </Draggable>
                            )
                        })
                    }
                    {provided.placeholder}
                    </div>
                )}
                </Droppable>
            </DragDropContext>}
            <ConfirmationPopUp
                openConfirmModal = {openConfirmModal}
                setOpenConfirmModal = {setOpenConfirmModal}
                message = {"You may have unsaved changes, Are you sure you want to navigate?"}
                successMethod = {navigateToEditBanner}
            />
        </>: <Loader />
    )
}

export default BlockBannerSelectionOld;